import React from "react";
import styles from "./style.scss";

export const Code = ({ children }) => {
    return <code className={styles.base}>{children}</code>;
};
